import Vue from 'vue';

// import './CmnMisControls';
import DataTable from './DataTable';
import AdvancedSearch from './AdvancedSearch';
import DataPaging from './DataPaging';
import CfgDescCfgForm from './CfgDescCfgForm';
import EditForm from './EditForm';
import DefaultListPanel from './DefaultListPanel';
import EditPanelSkeleton from './DefaultEditPanel/EditPanelSkeleton';
import DefaultEditPanel from './DefaultEditPanel';

import ListPanelMixin from './DefaultListPanel/ListPanelMixin';
import EditPanelMixin from './DefaultEditPanel/EditPanelMixin';

window.ListPanelMixin = ListPanelMixin;
window.EditPanelMixin = EditPanelMixin;

Vue.component("CgDataTable", DataTable);
Vue.component("CgAdvancedSearch", AdvancedSearch);
Vue.component("CgDataPaging", DataPaging);
Vue.component("CgCfgDescCfgForm", CfgDescCfgForm);
Vue.component("CgEditForm", EditForm);
Vue.component("CgDefaultListPanel", DefaultListPanel);
Vue.component("CgEditPanelSkeleton", EditPanelSkeleton);
Vue.component("CgDefaultEditPanel", DefaultEditPanel);

export {
    DataTable
};